module.exports = __webpack_public_path__ + "static/media/20210411_144024_738_IMG_0438.563a1895.jpg";